import * as React from 'react';
import InputText from '../../../../../common/components/InputText';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import Button from '../../../../../common/components/Button';
import {GLOBAL, LOAN_APPLICATION, LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import {HomeDataStepProps, HomeDataStepState} from '../../../../types/mx/creditoReal/components';
import * as OrientationTypes from '../../../../../common/components/OrientationTypes';
import Options from '../../../../../common/components/Options';
import Label from '../../../../../common/components/Label';
import {getNumberRangeCatalog} from '../../../../../common/utils/LoanUtils';
import DatePicker from '../../../../../common/components/DatePicker';
import {CR_DEPENDENT_CATALOG_ID} from '../../../../constants/MotorcreditConstants';
import FileUploader from '../../../../../common/components/FileUploader';
import * as FileTypeConstants from '../../../../../common/constants/FileTypeConstants';
import {
    DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES
} from '../../../../../common/constants/MimeTypeConstants';

class HomeDataStepView extends React.Component<HomeDataStepProps, HomeDataStepState> {
    constructor(props) {
        super(props);
        // @ts-ignore
        this.state = {
            showErrors: false
        };
        this.props.getLoanApplication();
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
        }, 200);
    }

    onPressNext = (skipNipValidation = false) => {
        if (this.props.hasNotErrorHomeDataFields) {
            return this.props.onPressNext(skipNipValidation);
        }
        this.setState({showErrors: true}, this.checkIfPressNext);
    }

    checkIfPressNext = () => {
        if (this.props.hasNotErrorHomeDataFields) {
            return this.props.onPressNext();
        }
    }

    onDropBillingFile = (accepted, type, section, error) => {
        this.props.onDropBillingFile(accepted, type, section, error);
    }

    render() {
        const {
            houseHoldMeasureSelectedField,
            houseHoldTimeSelectedField,
            onChangeHouseHoldMeasure,
            onChangeHouseHoldTime,
            lapse,
        } = this.props;

        const {showErrors} = this.state;
        return (
            <React.Fragment>
                <div className="row mb-3 d-none d-sm-none d-md-block">
                    <div className="col">
                        <h3 className="text-raleway text-secondary-lighten-1">{LOAN_APPLICATION_MX.ACTUAL_HOME}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.DOMICILE_ADDRESS}
                                    id={INPUTS.DOMICILE_ADDRESS}
                                    required={true}
                                    hasError={showErrors}
                                    labelError={this.props.addressField.error}
                                    value={this.props.addressField.value}
                                    onChange={this.props.onChangeAddress}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.DOMICILE_EXTERNAL_NUMBER}
                                    id={INPUTS.DOMICILE_EXTERNAL_NUMBER}
                                    required={true}
                                    hasError={showErrors}
                                    labelError={this.props.extNumberField.error}
                                    value={this.props.extNumberField.value}
                                    maxLength={20}
                                    onChange={this.props.onChangeExtNumber}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.DOMICILE_INTERNAL_NUMBER}
                                    id={INPUTS.DOMICILE_INTERNAL_NUMBER}
                                    value={this.props.intNumberField.value}
                                    maxLength={20}
                                    onChange={this.props.onChangeIntNumber}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.DOMICILE_POSTAL_CODE}
                                    id={INPUTS.DOMICILE_POSTAL_CODE}
                                    required={true}
                                    maxLength={5}
                                    minLength={5}
                                    type={InputTextTypes.NUMBER}
                                    acceptLeadingZeros={true}
                                    hasError={showErrors}
                                    labelError={this.props.postalCodeField.error}
                                    value={this.props.postalCodeField.value}
                                    onChange={this.props.onChangePostalCode}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.DOMICILE_STATE}
                                    id={INPUTS.DOMICILE_STATE}
                                    required={true}
                                    hasError={showErrors}
                                    labelError={this.props.stateField.error}
                                    value={this.props.stateField.value}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.DOMICILE_CITY}
                                    id={INPUTS.DOMICILE_CITY}
                                    hasError={showErrors}
                                    labelError={this.props.cityField.error}
                                    value={this.props.cityField.value}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_MUNICIPALITY}
                                    id={INPUTS.EMPLOYMENT_MUNICIPALITY}
                                    required={true}
                                    hasError={showErrors}
                                    labelError={this.props.municipalityField.error}
                                    value={this.props.municipalityField.value}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.EMPLOYMENT_COLONY}
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_COLONY}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.selectedColonyField.value}
                                    data={this.props.colonies}
                                    required={true}
                                    onChange={this.props.onChangeColony}
                                    labelError={this.props.selectedColonyField.error}
                                    hasError={showErrors}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.DOMICILE_PHONE}
                                    id={INPUTS.DOMICILE_PHONE}
                                    required={true}
                                    hasError={showErrors}
                                    labelError={this.props.phoneField.error}
                                    value={this.props.phoneField.value}
                                    maxLength={10}
                                    minLength={10}
                                    type={InputTextTypes.NUMBER}
                                    onChange={this.props.onChangePhone}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <div className="row">
                                    <div className="col">
                                        <Label text={LOAN_APPLICATION.HOME_ROOT} asterisk/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <SelectSearchComponent
                                            id={INPUTS.HOME_ROOT_YEAR_MONTH}
                                            placeholder={GLOBAL.SELECT}
                                            value={houseHoldMeasureSelectedField.value}
                                            data={lapse}
                                            required
                                            onChange={onChangeHouseHoldMeasure}
                                            labelError={houseHoldMeasureSelectedField.error}
                                            hasError={showErrors}
                                            showIconWarning={false}/>
                                    </div>
                                    <div className="col">
                                        <SelectSearchComponent
                                            id={INPUTS.HOME_ROOT}
                                            placeholder={GLOBAL.SELECT}
                                            value={houseHoldTimeSelectedField.value}
                                            data={getNumberRangeCatalog(99)}
                                            required
                                            onChange={onChangeHouseHoldTime}
                                            labelError={houseHoldTimeSelectedField.error}
                                            hasError={showErrors}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.DOMICILE_HOUSE_TYPE}
                                    label={LOAN_APPLICATION_MX.DOMICILE_HOUSE_TYPE}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.houseTypeSelectedField.value}
                                    data={this.props.crHouseTypeCatalog}
                                    required={true}
                                    onChange={this.props.onChangeHouseType}
                                    labelError={this.props.houseTypeSelectedField.error}
                                    hasError={showErrors}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3 d-none d-sm-none d-md-block">
                    <div className="col">
                        <h3 className="text-raleway text-secondary-lighten-1">{LOAN_APPLICATION_MX.WORK_INFO}</h3>
                    </div>
                </div>
                <div className="row mb-3 d-block d-sm-none d-sm-block d-md-none">
                    <div className="col">
                        <div className="step-name d-flex align-items-center justify-content-center">
                            {LOAN_APPLICATION_MX.WORK_INFO}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <Options
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_TYPES}
                                    id={INPUTS.EMPLOYMENT_TYPES}
                                    name={INPUTS.EMPLOYMENT_TYPES}
                                    options={this.props.employmentTypes}
                                    required={true}
                                    hasError={showErrors}
                                    labelError={this.props.employmentTypesField.error}
                                    onChange={this.props.onChangeEmploymentTypes}
                                    orientation={OrientationTypes.HORIZONTAL}
                                    listGroupClass="list-group-borderless"
                                    defaultValue={this.props.employmentTypesField.value?.value}/>
                            </div>
                            {this.props.employmentTypesField &&
                                this.props.employmentTypesField.value?.id !== CR_DEPENDENT_CATALOG_ID &&
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.EMPLOYMENT_BUSINESS_TYPE}
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_BUSINESS_TYPE}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.businessTypeSelectedField.value}
                                    data={this.props.crBusinessTypeCatalog}
                                    required={true}
                                    onChange={this.props.onChangeBusinessType}
                                    labelError={this.props.businessTypeSelectedField.error}
                                    hasError={showErrors}/>
                            </div>}
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <DatePicker
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_START_DATE}
                                    id={INPUTS.EMPLOYMENT_START_DATE}
                                    value={this.props.workingSinceField.value}
                                    required={true}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.workingSinceField.error}
                                    onChange={this.props.onChangeWorkingSince}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <Options
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_VALIDATE_INCOMES}
                                    id={INPUTS.EMPLOYMENT_VALIDATE_INCOMES}
                                    name={INPUTS.EMPLOYMENT_VALIDATE_INCOMES}
                                    options={this.props.booleanOptions}
                                    onChange={this.props.onChangeIncludeMonthlyIncomes}
                                    orientation={OrientationTypes.HORIZONTAL}
                                    listGroupClass="list-group-borderless"
                                    defaultValue={this.props.includeMonthlyIncomesField.value}/>
                            </div>
                            {this.props.includeMonthlyIncomesField.value &&
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_MONTHLY_INCOME}
                                    id={INPUTS.EMPLOYMENT_MONTHLY_INCOME}
                                    required={this.props.includeMonthlyIncomesField.value}
                                    hasError={showErrors}
                                    labelError={this.props.monthlyIncomesField.error}
                                    value={this.props.monthlyIncomesField.value}
                                    type={InputTextTypes.NUMBER}
                                    maxLength={9}
                                    minValue={0}
                                    onChange={this.props.onChangeMonthlyIncomes}/>
                            </div>}
                            {this.props.includeMonthlyIncomesField.value &&
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.EMPLOYMENT_DOCUMENT_TYPE}
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_DOCUMENT_TYPE}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.documentTypeSelectedField.value}
                                    data={this.props.crDocumentTypeCatalog}
                                    required={true}
                                    onChange={this.props.onChangeDocumentType}
                                    labelError={this.props.documentTypeSelectedField.error}
                                    hasError={showErrors}/>
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-sm-12 d-flex">
                        <Options
                            id={INPUTS.EMPLOYMENT_BILLING}
                            label={LOAN_APPLICATION_MX.EMPLOYMENT_BILLING}
                            name={INPUTS.EMPLOYMENT_BILLING}
                            options={this.props.billingTypes}
                            onChange={this.props.onChangeBillingType}
                            listGroupClass="list-group-borderless"
                            defaultValue={this.props.billingTypeField.value?.value}
                            required
                            labelError={this.props.billingTypeField.error}
                            hasError={showErrors}/>
                    </div>
                    {this.props.billingTypeField.value?.id === 'TAX' && (
                    <>
                    <div className="col-sm-12 col-md-8">
                        <SelectSearchComponent
                            id={INPUTS.EMPLOYMENT_TAX_REGIME}
                            label={LOAN_APPLICATION_MX.EMPLOYMENT_TAX_REGIME}
                            placeholder={GLOBAL.SELECT}
                            value={this.props.taxRegimeField.value}
                            data={this.props.taxRegimes}
                            required={true}
                            onChange={this.props.onChangeTaxRegime}
                            labelError={this.props.taxRegimeField.error}
                            hasError={showErrors}/>
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <FileUploader
                            id={INPUTS.EMPLOYMENT_BILLING_UPLOAD}
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            type={FileTypeConstants.PROOF_OF_TAX_STATUS_TYPE}
                            section={FileTypeConstants.WORK_SECTION}
                            label={LOAN_APPLICATION_MX.EMPLOYMENT_BILLING_FILE_UPLOAD}
                            required={false}
                            multiple={false}
                            onDrop={this.onDropBillingFile}
                            onDelete={this.props.onDeleteBillingFile}
                            onClickThumbnail={this.props.onClickBillingFileThumbnail}
                            uploadedFiles={this.props.billingFiles}
                            hasError={this.state.showErrors}
                            labelError={null}/>
                    </div>
                    </>
                    )}
                </div>
                <div className="row border-top">
                    <div className="col">
                        <div className="row mt-4 mb-3">
                            <div className="col-12 d-flex justify-content-between">
                                <Button text={GLOBAL.BACK} onPress={this.props.onPressBack} role="button"
                                        customClass="left px-md-5 d-none d-md-block" type="outlined"/>

                                <Button text={LOAN_APPLICATION_MX.NEXT}
                                        onPress={() => this.onPressNext(true)} role="button"
                                        customClass="right px-md-5 btn-block"/>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default HomeDataStepView;
